
import router from '@/router'
import { MessageBox } from 'element-ui';
import client from './client.js'
import { Message } from 'element-ui';
import {JSEncrypt} from "jsencrypt"
function util() {
    var _this = this;
    // 存储localStorage
    this.setStorage = (name, content) => {
        if (!name) return;
        if (typeof content !== 'string') {
            content = JSON.stringify(content);
        }
        window.localStorage.setItem(name, content);
    }

    // 获取localStorage
    this.getStorage = name => {
        if (!name) return;
        // let content = window.localStorage.getItem(name);
        return JSON.parse(window.localStorage.getItem(name));
    }

    // 删除localStorage
    this.removeStorage = name => {
        if (!name) return;
        window.localStorage.removeItem(name);
    }

    // 清除localStorage
    this.clearStorage = () => {
        window.localStorage.clear();
    }

    this.goTo = function(url, params = {}, delay = 0) {
        let default_params = {path: url};
        let new_params = Object.assign({}, default_params, params);
		setTimeout(function() {
			router.push(new_params);
		}, delay);
	};
    this.back = function(url, delay = 0) {
        var route = router.matcher.match(url);
        setTimeout(function() {
            router.go(-1);
        }, delay);
    };

    /*this.resetvalidate = function(formName){
       /!* if(this.$refs[formName]!==undefined){
            this.$refs[formName].clearValidate();
        }*!/
        this.$nextTick(()=>{
            this.$refs[formName].clearValidate();
    })
    };*/
    this.changeSelect = function(data){
        let ids=data.toString();
        let ids_list=ids.split(',');
        for(var i=0;i<ids_list.length;i++)
        {
            ids_list[i]=parseInt(ids_list[i]);
        }
        return ids_list;
    };

    this.getCheckedKeys = function(data, keys, key) {
        var res = [];
        recursion(data, false);
        return res;

        // arr -> 树形总数据
        // keys -> getCheckedKeys获取到的选中key值
        // isChild -> 用来判断是否是子节点
        function recursion (arr, isChild) {
            var aCheck = [];
            for ( var i = 0; i < arr.length; i++ ) {
                var obj = arr[i];
                aCheck[i] = false;

                if ( obj.children ) {
                    aCheck[i] = recursion(obj.children, true) ? true : aCheck[i];
                    if ( aCheck[i] ) {
                        res.push(obj[key]);
                    }
                }

                for ( var j = 0; j < keys.length; j++ ) {
                    if ( obj[key] == keys[j] ) {
                        aCheck[i] = true;
                        if ( res.indexOf(obj[key]) == -1 ) {
                            res.push(obj[key]);
                        }
                        break;
                    }
                }
            }
            if ( isChild ) {
                return aCheck.indexOf(true) != -1;
            }
        }
    }
}

export default new util;

